import { render } from "./Products.vue?vue&type=template&id=5b846858"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
script.render = render

export default script